import axios from 'axios'

export default {
  addToCart (data) {
    let url = '/api/cart/update'
    const params = {}
    if (data.recommendationId && data.recommendationType) {
      params[window.advAppContext.advAppData.url.recommendationIdQuerystring] = data.recommendationId
      params[window.advAppContext.advAppData.url.recommendationTypeQuerystring] = data.recommendationType
    }

    if (data.afterAddToCartRecommendationRequest) {
      params[window.advAppContext.advAppData.url.afterAddToCartRecommendationQueryString] = data.afterAddToCartRecommendationRequest
    }

    if (Object.keys(params).length !== 0) {
      url += '?' + new URLSearchParams(params).toString()
    }

    let cartProductCustomizations = {}
    if ('cartProductCustomizations' in data) {
      cartProductCustomizations = data.cartProductCustomizations
    }
    return axios.post(url, {
      productCodeId: data.productCodeId,
      quantity: data.quantity,
      cartProductCustomizations
    }).then(response => response.data)
  },
  /**
   * @typedef {Object} CartItem
   * @property {string} productCodeId
   * @property {number} quantity
   * @property {any} cartProductCustomizations
   * @property {string|null} recommendationId
   * @property {string|null} recommendationType
   */

  /**
   * Action to add items to the cart.
   * @param {CartItem[]} data - The payload containing the items to add to the cart.
   */
  massAddToCart (data) {
    return axios.post('/api/cart/massUpdate', data).then(response => response.data)
  },
  getTransporterData (data) {
    const languageAbbr = window.advAppContext.advAppData.languageAbbr
    return axios.post(`/${languageAbbr}/api/transporters/getAvailableTransporters`, {
      country: data.country,
      county: data.county,
      postal: data.postal,
      totalWithVat: data.totalWithVat,
      weight: data.weight
    })
      .then(response => response.data)
  },
  checkCoupon (data) {
    return axios.post('/order/preview_coupon', { coupon: data }).then(response => response.data)
  },
  validateVat (data) {
    return axios.post('/order/validateVat', { country: data.country, vat: data.vat }).then(response => response.data)
  },
  getRates (data) {
    return axios.post('/webrun/getAlbisLeaseRates', {
      netPrice: data.netPrice,
      productGroup: data.productGroup,
      downPayment: data.downPayment,
      contractType: data.contractType,
      paymentMethod: data.paymentMethod,
      commission: data.commission
    }).then(response => response.data)
  },
  createApplication (data) {
    return axios.post('/webrun/createAlbisLeaseApplication', {
      leaseObject: data.leaseObject,
      netPrice: data.netPrice,
      lesseeName: data.lesseeName,
      lesseeSurname: data.lesseeSurname,
      lesseePostalCode: data.lesseePostalCode,
      lesseePhone: data.lesseePhone,
      lesseeFax: data.lesseeFax,
      lesseeEmail: data.lesseeEmail,
      lesseeStreetAddress: data.lesseeStreetAddress,
      lesseeCity: data.lesseeCity,
      ceoName: data.ceoName,
      ceoSurname: data.ceoSurname,
      ceoStreetAddress: data.ceoStreetAddress,
      ceoPostalCode: data.ceoPostalCode,
      ceoCity: data.ceoCity,
      ceoDob: data.ceoDob,
      ceoPhone: data.ceoPhone,
      ceoFax: data.ceoFax,
      iban: data.iban,
      specialLeasePayments: data.specialLeasePayments,
      leaseTermMonths: data.leaseTermMonths,
      rate: data.rate, //
      legalForm: data.legalForm,
      ceoSalutation: data.ceoSalutation,
      commissionPercentage: data.commissionPercentage,
      objectInsurance: data.objectInsurance,
      productGroup: data.productGroup,
      contractType: data.contractType,
      paymentMethod: data.paymentMethod,
      serviceFee: data.serviceFee,
      sendContractEmail: data.sendContractEmail,
      productId: data.productId
    }).then(response => response.data)
  }
}
